"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = require("react-bootstrap");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ErgAuth = (_temp2 = _class = function (_Component) {
  _inherits(ErgAuth, _Component);

  function ErgAuth() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ErgAuth);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ErgAuth.__proto__ || Object.getPrototypeOf(ErgAuth)).call.apply(_ref, [this].concat(args))), _this), _this.handleRefresh = function () {
      _this.props.getUser(false);
    }, _this.handleLogin = function (evt) {
      evt.preventDefault();
      evt.stopPropagation();
      _this.props.onLogin();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ErgAuth, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      // TODO: make sure authService is deleted when component unmounts and that
      // all events listeners inside authService are killed
      this.props.authService.on("refresh", this.handleRefresh);
      this.props.getUser();
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      // Try to automaticallt login when
      //  - Token is not present
      //  - User was not previously logged in
      //
      // This will cause redirect loop only in case ID service does not set a
      // token and still redirects back to the app
      //
      // TODO: Fix the rare case when ID service fails to set the token
      var isLoggedIn = this.props.isLoggedIn;

      if (!isLoggedIn && !nextProps.isLoggedIn && nextProps.error === "missing-token") {
        this.props.authService.authenticate();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.authService.off("refresh");
    }
  }, {
    key: "renderError",
    value: function renderError() {
      return _react2.default.createElement(
        _reactBootstrap.Alert,
        { bsStyle: "danger", className: "erg-components-ErgAuth text-center" },
        "Could not log in. ",
        _react2.default.createElement(
          "a",
          { href: "/", onClick: this.handleLogin },
          "Click here to try again"
        ),
        ".",
        _react2.default.createElement("br", null),
        "Contact an adminstrator if the problem persists."
      );
    }
  }, {
    key: "renderGuest",
    value: function renderGuest() {
      return _react2.default.createElement(
        _reactBootstrap.Alert,
        { bsStyle: "info", className: "erg-components-ErgAuth text-center" },
        "You are not logged in. ",
        _react2.default.createElement(
          "a",
          { href: "/", onClick: this.handleLogin },
          "Click here to login with your Ergeon account"
        ),
        "."
      );
    }
  }, {
    key: "renderLoading",
    value: function renderLoading() {
      return _react2.default.createElement(
        _reactBootstrap.Alert,
        { bsStyle: "info", className: "erg-components-ErgAuth text-center" },
        _react2.default.createElement(_reactBootstrap.ProgressBar, { active: true, bsStyle: "info", label: "Logging in", now: 100 })
      );
    }
  }, {
    key: "renderUnauthorized",
    value: function renderUnauthorized() {
      var appName = this.props.appName;

      return _react2.default.createElement(
        _reactBootstrap.Alert,
        { bsStyle: "danger", className: "erg-components-ErgAuth text-center" },
        "You don't have the authorization to use the ",
        appName,
        " app. Please contact an Administrator and ",
        _react2.default.createElement(
          "a",
          { href: "/", onClick: this.handleLogin },
          "click here to try again"
        ),
        "."
      );
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          error = _props.error,
          isLoading = _props.isLoading,
          isLoggedIn = _props.isLoggedIn;


      if (isLoggedIn) {
        return null;
      }

      if (isLoading) {
        return this.renderLoading();
      }

      if (error) {
        if (error === "not-authorized") {
          return this.renderUnauthorized();
        } else if (["missing-token", "not-authenticated"].indexOf(error) !== -1) {
          return this.renderGuest();
        }
        return this.renderError();
      }
      return this.renderGuest();
    }
  }]);

  return ErgAuth;
}(_react.Component), _class.displayName = "ErgAuth", _class.propTypes = {
  appName: _propTypes2.default.string.isRequired,
  authService: _propTypes2.default.object.isRequired,
  error: _propTypes2.default.string,
  getUser: _propTypes2.default.func.isRequired,
  isLoading: _propTypes2.default.bool.isRequired,
  isLoggedIn: _propTypes2.default.bool.isRequired,
  onLogin: _propTypes2.default.func.isRequired
}, _temp2);
exports.default = ErgAuth;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@ergeon/erg-components-react/lib/ErgAuth.js
 ** module id = 783
 ** module chunks = 0
 **/